module.exports = __webpack_public_path__ + "static/media/41fef6a9-3689-4810-afa4-540d17dbefc0.619bb8c6.png";